export const FETCH_HOST_FILES_CONFIG_REQUEST = 'FETCH_HOST_FILES_CONFIG_REQUEST';
export const FETCH_HOST_FILES_CONFIG_SUCCESS = 'FETCH_HOST_FILES_CONFIG_SUCCESS';
export const FETCH_HOST_FILES_CONFIG_FAILURE = 'FETCH_HOST_FILES_CONFIG_FAILURE';

export const FETCH_HOST_FILES_REQUEST = 'FETCH_HOST_FILES_REQUEST';
export const FETCH_HOST_FILES_SUCCESS = 'FETCH_HOST_FILES_SUCCESS';
export const FETCH_HOST_FILES_FAILURE = 'FETCH_HOST_FILES_FAILURE';

export const FETCH_HOST_FILES_COUNTS_REQUEST = 'FETCH_HOST_FILES_COUNTS_REQUEST';
export const FETCH_HOST_FILES_COUNTS_SUCCESS = 'FETCH_HOST_FILES_COUNTS_SUCCESS';
export const FETCH_HOST_FILES_COUNTS_FAILURE = 'FETCH_HOST_FILES_COUNTS_FAILURE';

export const UPLOAD_HOST_FILE_REQUEST = 'UPLOAD_HOST_FILE_REQUEST';
export const UPLOAD_HOST_FILE_SUCCESS = 'UPLOAD_HOST_FILE_SUCCESS';
export const UPLOAD_HOST_FILE_FAILURE = 'UPLOAD_HOST_FILE_FAILURE';
export const UPLOAD_HOST_FILE_PROGRESS = 'UPLOAD_HOST_FILE_PROGRESS';
export const UPLOAD_HOST_FILE_BATCH_PROGRESS = 'UPLOAD_HOST_FILE_BATCH_PROGRESS';

export const RENAME_HOST_FILE_REQUEST = 'RENAME_HOST_FILE_REQUEST';
export const RENAME_HOST_FILE_SUCCESS = 'RENAME_HOST_FILE_SUCCESS';
export const RENAME_HOST_FILE_FAILURE = 'RENAME_HOST_FILE_FAILURE';

export const REASSIGN_HOST_FILE_REQUEST = 'REASSIGN_HOST_FILE_REQUEST';
export const REASSIGN_HOST_FILE_SUCCESS = 'REASSIGN_HOST_FILE_SUCCESS';
export const REASSIGN_HOST_FILE_FAILURE = 'REASSIGN_HOST_FILE_FAILURE';

export const DELETE_HOST_FILE_REQUEST = 'DELETE_HOST_FILE_REQUEST';
export const DELETE_HOST_FILE_SUCCESS = 'DELETE_HOST_FILE_SUCCESS';
export const DELETE_HOST_FILE_FAILURE = 'DELETE_HOST_FILE_FAILURE';

export const VIEW_HOST_FILE_REQUEST = 'VIEW_HOST_FILE_REQUEST';
export const VIEW_HOST_FILE_FAILURE = 'VIEW_HOST_FILE_FAILURE';

export const DOWNLOAD_HOST_FILE_REQUEST = 'DOWNLOAD_HOST_FILE_REQUEST';
export const DOWNLOAD_HOST_FILE_FAILURE = 'DOWNLOAD_HOST_FILE_FAILURE';

export const CLEAR_HOST_FILES_STATUS = 'CLEAR_HOST_FILES_STATUS';
